<template>    
<span>

  <base-button  size="sm" :disabled="checkForPartnerNationCondition || isReadOnly"   class="btn-dark" @click="openVerifyPinModal=true" v-if="!isSigned && isPartnerAccount ">Verfiy Pin</base-button>
        <el-dialog
  title="Verify Pin"
  :visible.sync="openVerifyPinModal"
  width="30%"
  center
  >
            <el-input
                placeholder="Pin"
                v-model="pin"
                name="pin"
                 v-validate="'required'" 
                                :error="getError('pin')" 
              >
              </el-input>
               <span v-show="errors.has('pin')" class="error">
                            Pin is required.
                        </span>
              <br/>
            <div style="margin-top: 20px;text-align: right">
        <base-button
            type="danger"
            class="alert_footer_button btn_extra_small btn_info mr-4"
            @click="openVerifyPinModal=false"
          >
            Close
          </base-button>

              <base-button   type="primary"
            class="alert_footer_button btn_extra_small btn_info mr-4" 
              @click="verifyPin">Submit</base-button> 
</div>
</el-dialog>
</span>
</template>

<script>
import { Button , Dialog } from "element-ui";
import { mapGetters } from 'vuex';
export default {
    components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    },
    props: {
        checkForPartnerNationCondition: {
            type: Boolean,
            default: false,
        },
         isReadOnly: {
            type: Boolean,
            default: false,
         },
        isPartnerAccount: {
            type: Boolean,
            default: false,
        },
            },
    data(){
    return {
    openVerifyPinModal: false,
        pin: '',
      isSigned: false,
    
}
  },
  computed: {
    ...mapGetters({
      getUser: "authentication/getUser",
      isAuthorized: "orderMetadata/isAuthorized",
    }),
  },
    methods: {
      async verifyPin() {
      try {
        var email = this.getUser.email;
        let data = {
          'partnerNationUserEmail': email,
          'pin': this.pin,
          'orderId': this.$route.path.split('/').pop()
        }
       const res = await this.axios.post('api/pin/pn/signature/validation', data);
        if (!this.isSigned && res) {
            this.isSigned = true
         this.$emit('pinVerify', this.isSigned, this.pin);
         this.openVerifyPinModal = false
        } else {
            this.isSigned = false
         this.$emit('pinVerify', this.isSigned, this.pin);
         
       }
      } catch (e) {
         this.$toast.error('Invalid pin. Please enter a valid pin')
        throw e
      }
        },
      getError(fieldName) {
      return this.errors.first(fieldName);
    },
    }
}

</script>